/**
 * Catalog MV2 query API — isolated from MV1 pages/Catalog.jsx.
 */
import { getCatalogProducts } from "@/lib/api";

export const CATALOG_PRODUCTS_QUERY_KEY = "catalog-products";

export async function fetchCatalogProductsFromApi(signal) {
  const res = await getCatalogProducts({ active_only: false });
  if (signal?.aborted) throw new DOMException("Aborted", "AbortError");
  return res.data.products || [];
}
